export interface ApiMeta {
  timestamp: string;
  success: boolean;
}

export interface ApiSuccessResponse<T> {
  data: T;
  meta: ApiMeta;
  statusCode: number;
}

export interface ApiErrorDetails {
  message: string;
  error: string;
  statusCode: number;
}

export interface ApiErrorResponse {
  error: ApiErrorDetails;
  meta: ApiMeta;
}

export type ApiResponse<T extends object = Record<string, any>> =
  | ApiSuccessResponse<T>
  | ApiErrorResponse;

export interface FetchOptions {
  method?: "GET" | "POST" | "PUT" | "DELETE" | "PATCH";
  body?: any;
  headers?: Record<string, string>;
  cache?: RequestCache;
  revalidate?: number | false;
  tags?: string[];
  /** Abort in-flight fetch (React Query passes this for typeahead cancellation). */
  signal?: AbortSignal;
  /**
   * Show the generic error toast on a failed response. Defaults to `true`.
   * Set to `false` when the caller renders its own failure state.
   */
  showErrorToast?: boolean;
  /**
   * HTTP statuses that are expected for this call (e.g. 404 for optional resources).
   * Skips error logging / Sentry for matching responses; still returns an ApiErrorResponse.
   */
  ignoreStatusCodes?: number[];
}

export function isApiError<T extends object>(
  response: ApiResponse<T>
): response is ApiErrorResponse {
  return "error" in response;
}

export interface ApiPaginationStructure<T> {
  total: number;
  page: number;
  limit: number;
  totalPages: number;
  /** 1-based index of the first item on the current page */
  startIndex?: number;
  /** 1-based index of the last item on the current page */
  endIndex?: number;
  result: T;
}

export enum EntryPoint {
  HOME = "home",
  PLP = "plp",
  PDP = "pdp",
  UTM = "utm",
  STORY = "story",
  ABOUT = "about",
  CONTACT = "contact",
}
